/**
 * Publisher filtering utility. Google is gated solely by the
 * ENABLE_GOOGLE_DEMANDGEN feature flag, which is set per stage in
 * PVMMELeelaServiceCDK/lib/constants.ts (FEATURE_FLAG_DEFAULTS).
 *
 * No LDAP/Brass check is involved: integ-test identities aren't members of any
 * Amazon LDAP group, so a membership gate makes the option unreachable in tests.
 */
import { CampaignPublishers } from 'src/store/constants';
import { FEATURE_FLAGS } from 'src/constants';
import { isFeatureEnabled } from 'src/feature-flags';
import type { CampaignDesiredStateDto } from 'src/store/generated/leela-api-generated';

/**
 * Returns the list of publishers available to the current user.
 * Google appears only when ENABLE_GOOGLE_DEMANDGEN is on for the stage.
 * Fails closed: if the flag cache isn't populated yet, google is excluded.
 */
export const getAvailablePublishers = (): Array<CampaignDesiredStateDto['publisher']> =>
  Object.values(CampaignPublishers).filter(
    p => p !== CampaignPublishers.GOOGLE || isFeatureEnabled(FEATURE_FLAGS.ENABLE_GOOGLE_DEMANDGEN),
  );
